import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { TechmoreSharedModule } from '@techmore/share';
import { NgxPageScrollModule } from 'ngx-page-scroll';
import { ShareModule } from 'src/app/share/share.module';
import { TemplateShareModule } from '../../share-template.module';
import { IndexComponent } from './index/index.component';
import { SearchToolModalComponent } from './search-tool-modal/search-tool-modal.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { GlobalModule } from '@techmore/global';


@NgModule({
  declarations: [IndexComponent, SearchToolModalComponent],
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule.forChild(),
    GlobalModule,
    NgxPageScrollModule,
    TechmoreSharedModule,
    ShareModule,
    TemplateShareModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
  ],
  entryComponents: [IndexComponent]
})
export class Template040Module {
  static entry = IndexComponent;
}
